module.exports = __webpack_public_path__ + "img/cooperation_banner@.af81b025.png";